/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Popover, DatePicker } from 'antd'
import Cookies from "universal-cookie";
import { get, map, find, filter, isEmpty } from 'lodash'
import { FilterIcon } from "../../../../../../components/icons"

const cookies = new Cookies();

export default class FilterUser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadPageFromDashboard: false,
      clientType: "all_clients",
      userRole: 'superadmin',
      visible: false,
      hideInactive: false,



      // Current subgroup selected values
      clientStatus: [],
      clientSuburb: [],
      clientStrategist: [],
      clientTiming: [],
      clientAgent: [],

      // Value of subgroup search filter
      searchStatus: "",      
      searchAgent: "",
      searchSuburb: "",

      // Subgroup checkbox
      status: false,
      strategists: false,
      agents: false,
      suburb: false,
      createdDate: false,

      // Expand subgroup 
      statusDropdown: false,
      strategistsDropDown: false,
      filterStrategistDropdown: false,
      filterSuburbDropdown: false,
      
      // Subgroup values 
      filteredStrategists: [],
      filteredSuburb: [],
      filterSearch: [],
      filteredAgents: [],      
      selectedCreatedDate: "",      
      selectedEndDate: "",
      filteredTimings: [],

      // Subgroup selected 
      filteredClientTiming: [],
      filteredClientStrategist: [],
      filteredClientAgent: [],
      filteredClientSuburb: [],      
      

      filterCount: 0,
      activePage: 1,


      sortByKey: "",
      sortByType: 0,

      timingCheckBox: false,
      filterTimingsDropDown: false,

      // searchTimings: "",
    }

  }

  componentDidMount() {
    if (this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.to) {
      const { from, to } = this.props.location.state;
      localStorage.setItem('from_date', from);
      this.handleDateChange(moment.utc(from).format('MM/DD/YYYY'), 'start');
      this.handleDateChange(to, 'end');
    }


    const user = cookies.get("user");
    if (user && user.role === "strategist") {
      this.setState({ clientType: 'my_clients', userRole: "strategist" });
    }
    const localclientdata = JSON.parse(localStorage.getItem("clientFilterData"));
    if (user && localclientdata) {
      this.setState({
        status: localclientdata && localclientdata.clientStatus && localclientdata.clientStatus.length > 0,
        strategists: localclientdata && localclientdata.clientStrategist && localclientdata.clientStrategist.length > 0,
        agents: localclientdata && localclientdata.clientAgent && localclientdata.clientAgent.length > 0,
        suburb: localclientdata && localclientdata.clientSuburb && localclientdata.clientSuburb.length > 0,

        timingCheckBox: localclientdata && localclientdata.clientTiming && localclientdata.clientTiming.length > 0,
        
        statusDropdown: localclientdata && localclientdata.clientStatus && localclientdata.clientStatus.length > 0,
        filterStrategistDropdown: localclientdata && localclientdata.clientStrategist && localclientdata.clientStrategist.length > 0,
        filterTimingsDropDown: localclientdata && localclientdata.clientTiming && localclientdata.clientTiming.length > 0,
        filterSuburbDropdown: localclientdata && localclientdata.clientSuburb && localclientdata.clientSuburb.length > 0,
      
        clientStatus: localclientdata && localclientdata.clientStatus ? localclientdata.clientStatus : [],        
        clientAgent: localclientdata && localclientdata.clientAgent ? localclientdata.clientAgent : [],

        filteredStrategists: localclientdata && localclientdata.clientStrategist ? localclientdata.clientStrategist : [],
        filteredAgents: localclientdata && localclientdata.clientAgent ? localclientdata.clientAgent : [],
        filteredTimings: localclientdata && localclientdata.clientTiming ? localclientdata.clientTiming : [],
        filteredSuburb: localclientdata && localclientdata.clientSuburb ? localclientdata.clientSuburb : [],
        filterCount: localclientdata && localclientdata.filterCount ? localclientdata.filterCount : 0,

        selectedCreatedDate: localclientdata && localclientdata.startDate ? moment.utc(localclientdata.startDate) : "",
        selectedEndDate: localclientdata && localclientdata.endDate ? moment.utc(localclientdata.endDate) : "",
        createdDate: localclientdata && localclientdata.endDate !== "" && localclientdata.startDate !== ""
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    const pageState = {
      totalPages: Math.round(
        props.clientsData &&
        props.clientsData.user_counts &&
        state.clientType &&
        props.clientsData.user_counts[state.clientType]
      ),
      clientLimit: props.resultEntry
    };
    if (get(props, "location.state.filter", false)) {
      const clientStatus = []
      switch (props.location.state.filter) {
        case "Call Scheduled":
          clientStatus.push("Call Scheduled")
          break;
        case "Green":
          clientStatus.push("Green")
          break;
        case "Green - Actively Engaged":
          clientStatus.push("Green - Actively Engaged")
          break;
        case "Green - Not Very Engaged":
          clientStatus.push("Green - Not Very Engaged")
          break;
        case "Green - Somewhat Engaged":
          clientStatus.push("Green - Somewhat Engaged")
          break;
        case "Never Had A Call":
          clientStatus.push("Never Had A Call")
          break;
        case "Online-New":
          clientStatus.push("Online-New")
          break;
        case "Trying To Schedule":
          clientStatus.push("Trying To Schedule")
          break;
        default:
          break;
      }
      const user = cookies.get("user");
      const data = {
        pageLimit: 20,
        activePage: 1,
        clientStatus,
        clientStrategist: [],
        clientTiming: [],
        clientSuburb: [],
        clientAgent: [],
        clientType: user && user.role === "strategist" ? "my_clients" : "all_clients",
        hideInactive: false,
        sortBy: { key: "", type: 0 },
        startDate: "",
        endDate: "",
      }
      localStorage.setItem("strategistFilterData", JSON.stringify({ ...data, filterCount: 0 }));
      props.getClientList(data)
      props.setfilterParams({ clientStatus, filteredTimings: [], filteredStrategists: [], filteredSuburb: [], filteredAgents: [], startDate: "", endDate: "", filterCount: 1 })
      props.history.replace({ pathname: '/strategist/clients/all-clients', state: {} })
      return { ...state, clientStatus, statusDropdown: true, status: true, filterCount: 1, ...pageState }
    }
    return { ...state, ...pageState }
  }
  // on click of filter item
  filterClick = (filterType, e) => {

    if (e) e.preventDefault();
    
    let filterCount = this.state.filterCount
    
    const { filteredTimings, filteredStrategists, filteredSuburb, filteredAgents, clientStatus, selectedCreatedDate, selectedEndDate } = this.state
    const { filterParams } = this.props;

    switch (filterType) {
      case "status": {
        const filterSearch = filterParams && filterParams.data && filterParams.data.statuses;
        filterCount = this.state.status ? filterCount - 1 : filterCount + 1
        if (this.state.status) {
          this.setState({ status: false, statusDropdown: false, filteredTimings: [], filterSearch })
          this.props.setfilterParams({ clientStatus: [], filteredTimings, filteredStrategists, filteredSuburb, startDate: selectedCreatedDate, endDate: selectedEndDate, filterCount })
        } else {
          this.setState({ status: true, statusDropdown: true, filterSearch })
        }
        break
      }
      case "timings": {
        const filteredClientTiming = this.props.timings;
        filterCount = this.state.timingCheckBox ? filterCount - 1 : filterCount + 1
        if (this.state.timingCheckBox) {
          this.setState({ timingCheckBox: false, filterTimingsDropDown: false, filteredTimings: [], filteredClientTiming })
          this.props.setfilterParams({ clientStatus, filteredTimings: [], filteredStrategists, filteredSuburb, startDate: selectedCreatedDate, endDate: selectedEndDate, filterCount })
        } else {
          this.setState({ timingCheckBox: true, filterTimingsDropDown: true, filteredClientTiming })
        }        
        break
      }      
      case "strategist": {
        const filteredClientStrategist = this.getAllStrategists();
        filterCount = this.state.strategists ? filterCount - 1 : filterCount + 1
        if (this.state.strategists) {
          this.setState({
            strategists: false,
            filterStrategistDropdown: false,
            filteredStrategists: [],
            filteredClientStrategist
          })
          this.props.setfilterParams({ clientStatus, filteredTimings, filteredStrategists: [], filteredSuburb, startDate: selectedCreatedDate, endDate: selectedEndDate, filterCount })
        } else {
          this.setState({
            strategists: true,
            filterStrategistDropdown: true,
            filteredClientStrategist
          })
        }        
        break
      }
      case "suburb": {
        const filteredClientSuburb = filterParams && filterParams.data && filterParams.data.suburbs;
        filterCount = this.state.suburb ? filterCount - 1 : filterCount + 1
        if (this.state.suburb) {
          this.setState({
            suburb: false,
            filterSuburbDropdown: false,
            filteredSuburb: [],
            filteredClientSuburb
          })
          this.props.setfilterParams({ clientStatus, filteredTimings, filteredStrategists, filteredSuburb: [], startDate: selectedCreatedDate, endDate: selectedEndDate, filterCount })
        } else {
          this.setState({
            suburb: true,
            filterSuburbDropdown: true,
            filteredClientSuburb
          })
        }
        break
      }
      case "createdDate": {
        filterCount = this.state.createdDate ? filterCount - 1 : filterCount + 1
        if (this.state.createdDate) {
          this.setState({ createdDate: false, selectedCreatedDate: "" })
          this.props.setfilterParams({ clientStatus, filteredTimings, filteredStrategists, filteredSuburb, startDate: "", endDate: "", filterCount })
        } else {
          this.setState({ createdDate: true })
        }        
        break
      }
      case "agent": {
        const filteredClientAgent = filterParams.data.agents
        filterCount = this.state.agents ? filterCount - 1 : filterCount + 1
        if (this.state.agents) {
          this.setState({
            agents: false,
            filterAgentDropdown: false, 
            filteredAgent: [],
            filteredClientAgent
          })
          this.props.setfilterParams({ clientStatus, filteredTimings, filteredStrategists: [], filteredAgents: [], filteredSuburb, startDate: selectedCreatedDate, endDate: selectedEndDate, filterCount })
        } else {
          this.setState({
            agents: true,
            filterAgentDropdown: true,
            filteredClientAgent
          })
        }        
      }
      default: {
        break
      }
    }

    this.setState({ filterCount })
    this.forceUpdate()
  }

  clearFilter = () => this.setState({
    clientStatus: [],
    statusDropdown: false,
    status: false,
    filterCount: 0,
    filteredSuburb: [],
    strategists: false,
    searchStatus: "",
    strategistsDropDown: false,
    suburb: false,
    createdDate: false,
    selectedCreatedDate: "",
    selectedEndDate: "",
    filteredStrategists: [],
    selectedStrategist: [],
    filteredClientSuburb: [],
    clientSuburb: [],
    clientStrategist: [],
    clientAgent: [],
    filterSuburbDropdown: false,
    filteredClientStrategist: [],
    filterStrategistDropdown: false,

    timingCheckBox: false,
    filterTimingsDropDown: false,
    filteredTimings: [],
    filteredClientTiming: [],
    clientTiming: [],
    // searchTimings: "",

  }, () => {
    this.props.setfilterParams({ clientStatus: [], filteredTimings: [], filteredStrategists: [], filteredTimings: [], filteredSuburb: [], startDate: "", endDate: "", filterCount: 0 })
    this.fetchFilterResult()
  });

  resetHeadFilterParams = data => {
    let filterCount = 0;
    
    filterCount += data.selectedClientStatus && data.selectedClientStatus.length > 0 ? 1 : 0
    filterCount += data.selectedClientStrategists && data.selectedClientStrategists.length > 0 ? 1 : 0
    filterCount += data.selectedClientTimings && data.selectedClientTimings.length > 0 ? 1 : 0
    filterCount += data.selectedClientSuburbs && data.selectedClientSuburbs.length > 0 ? 1 : 0
    filterCount += data.selectedClientAgents && data.selectedClientAgents.length > 0 ? 1 : 0

    this.setState({
      filterCount,
      clientSuburb: get(data, 'selectedClientSuburbs', []),
      status: data.selectedClientStatus && data.selectedClientStatus.length > 0,
      strategists: data.selectedClientStrategists && data.selectedClientStrategists.length > 0,
      agents: data.selectedClientAgents && data.selectedClientAgents.length > 0,
      timingCheckBox: data.selectedClientTimings && data.selectedClientTimings.length > 0,
      suburb: data.selectedClientSuburbs && data.selectedClientSuburbs.length > 0,
      statusDropdown: data.selectedClientStatus && data.selectedClientStatus.length > 0,
      filterStrategistDropdown: data.selectedClientStrategists && data.selectedClientStrategists.length > 0,
      filterAgentDropdown: data.selectedClientAgents && data.selectedClientAgents.length > 0,
      filterTimingsDropDown: data.selectedClientTimings && data.selectedClientTimings.length > 0,
      filterSuburbDropdown: data.selectedClientSuburbs && data.selectedClientSuburbs.length > 0,
      clientStatus: data.selectedClientStatus ? data.selectedClientStatus : [],
      clientStrategist: get(data, 'selectedClientStrategists', []),
      // clientTiming: this.props.timings ? this.props.timings : [],
      filteredStrategists: data.selectedClientStrategists ? data.selectedClientStrategists : [],
      filteredTimings: data.selectedClientTimings ? data.selectedClientTimings : [],
      filteredAgents: data.selectedClientAgents ? data.selectedClientAgents :  [],
      clientTiming: data.selectedClientTimings ? data.selectedClientTimings : [],
      filteredSuburb: data.selectedClientSuburbs ? data.selectedClientSuburbs : [],
      selectedCreatedDate: data.startDate ? moment.utc(data.startDate) : "",
      selectedEndDate: data.endDate ? moment.utc(data.endDate) : "",
      createdDate: data.startDate !== "" && data.endDate !== ""
    }, () => this.fetchFilterResult())
    if (filterCount === 0) {
      this.clearFilter()
    }
    this.forceUpdate()
  }

  fetchFilterResult = () => {
    const { activePage, filterCount, clientStatus, clientAgent, clientTiming, clientStrategist, clientSuburb, sortByType, sortByKey, hideInactive, selectedCreatedDate, selectedEndDate } = this.state
    let { clientType } = this.state;
    const cType = get(this, 'props.location.pathname').includes('clients/all-clients') ? 'all_clients' : clientType

    const { resultEntry } = this.props;
    const user = cookies.get("user");
    if (user && user.role === "strategist") {
      clientType = "my_clients"
      this.setState({ clientType: "my_clients" });
    }
    const data = {
      clientType: cType,
      clientStatus,
      clientSuburb,
      clientTiming,
      clientAgent,
      clientStrategist,
      hideInactive,
      pageLimit: resultEntry,
      activePage,
      startDate: selectedCreatedDate,
      endDate: selectedEndDate,
      sortBy: { key: sortByKey, type: sortByType }
    }
    const currentUrl = get(this.props, "location.pathname", "")
    if (currentUrl === '/strategist/clients' && currentUrl === '/strategist/clients/new-clients') {
      this.props.getClientList(data)
    } else if (currentUrl === '/strategist/clients/all-clients') {
      this.props.getClientList(data)
    }
    localStorage.setItem('clientFilterData', JSON.stringify({ ...data, filterCount }))
  }

  filterClient = (id, type, e) => {
    const { clientStatus, filteredStrategists, filteredTimings, filteredSuburb, selectedCreatedDate, selectedEndDate, filteredAgents, filterCount } = this.state
    switch (type) {

      case 'filterStatus': {
        if (clientStatus.indexOf(id) === -1) {
          clientStatus.push(id)
        } else {
          clientStatus.splice(clientStatus.indexOf(id), 1)
        }
        this.setState({ clientStatus })
        break
      }
      case 'filterTiming': {
        if (filteredTimings.indexOf(id) === -1) {
          filteredTimings.push(id)
        } else {
          filteredTimings.splice(filteredTimings.indexOf(id), 1)
        }
        this.setState({ filteredTimings, clientTiming: filteredTimings })        
        break
      }
      case 'filterStrategist': {
        if (filteredStrategists.indexOf(id) === -1) {
          filteredStrategists.push(id)
        } else {
          filteredStrategists.splice(filteredStrategists.indexOf(id), 1)
        }
        this.setState({ filteredStrategists, clientStrategist: filteredStrategists })        
        break
      }
      case 'filterSuburb': {
        if (filteredSuburb.indexOf(id) === -1) {
          filteredSuburb.push(id)
        } else {
          filteredSuburb.splice(filteredSuburb.indexOf(id), 1)
        }
        this.setState({ filteredSuburb, clientSuburb: filteredSuburb })        
        break
      }
      case 'filterAgent': {

        if (filteredAgents.indexOf(id) === -1) {
          filteredAgents.push(id)
        } else {
          filteredAgents.splice(filteredAgents.indexOf(id), 1)
        }
        this.setState({ filteredAgents, clientAgent: filteredAgents })                
        break
      }
      default: {
        break
      }                              
    }

    this.props.setfilterParams({ 
      clientStatus, 
      filteredTimings, 
      filteredStrategists, 
      filteredSuburb,
      filteredAgents,
      startDate: selectedCreatedDate, 
      endDate: selectedEndDate, 
      filterCount 
    })
    this.forceUpdate()
    // this.fetchFilterResult()
  }

  // show visible filter
  filterVisible = visible => {
    const { filterParams } = this.props;
    const filterSearch = filterParams && filterParams.data && filterParams.data.statuses;
    const filteredClientStrategist = this.getAllStrategists();  
    const filteredClientTiming = this.props.timings;
    const filteredClientSuburb = filterParams && filterParams.data && filterParams.data.suburbs;
    const filteredClientAgents = filterParams && filterParams.data && filterParams.data.agents
    this.setState({ visible, filterSearch, filteredClientTiming, filteredClientStrategist, filteredClientSuburb, filteredClientAgents })
  }

  // change fileter value with selection for select
  handleChange = ({ target }) => {
    const { name, value } = target
    this.setState({ [name]: value })
    const { filterParams } = this.props;
    switch(name) {
      case "searchStatus": {
        const strategistStatus = filterParams && filterParams.data && filterParams.data.statuses;
        const filterSearch = filter(strategistStatus, search => search.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
        this.setState({ filterSearch })
        break
      }

      case "searchTimings": {
        const timingStatus = this.props.timings
        const filteredClientTiming = filter(timingStatus, search => search.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
        this.setState({ filteredClientTiming })
        break
      }

      case "searchStrategist": {
        const strategistStatus = this.getAllStrategists();
        const filteredClientStrategist = filter(strategistStatus, search => search.strategist_name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
        this.setState({ filteredClientStrategist })
        break
      }

      case "searchSuburb": {
        const strategistStatus = filterParams && filterParams.data && filterParams.data.suburbs;
        const filteredClientSuburb = filter(strategistStatus, search => search.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
        this.setState({ filteredClientSuburb })
        break
      }

      case "searchAgent": {
        const agents = filterParams && filterParams.data && filterParams.data.agents
        const filteredClientAgent = agents.filter(a => a.agent_name.toLowerCase().includes(value.toLowerCase()))
        this.setState({ filteredClientAgent })
        break
      }
    }
    
    this.forceUpdate()
  }

  // change status close filter model with
  closeFilterModel = () => this.setState({ visible: !this.state.visible })


  // get all strategist
  getAllStrategists = () => {
    const { filterParams } = this.props;
    const auth = cookies.get("i_user");
    const user = cookies.get("user");
    let allStrategists = filterParams && filterParams.data && filterParams.data.strategists;
    if (
      auth &&
      auth.role !== "superadmin" &&
      auth.role !== "admin"
    ) {
      allStrategists = filter(
        allStrategists,
        s => s.role !== "former-strategist-inactive"
      );
    } else if (!auth && user && user.role == "strategist") {
      allStrategists = filter(
        allStrategists,
        s => s.role !== "former-strategist-inactive"
      );
    }
    return allStrategists;
  }
  // handle change and filter data based on date
  handleDateChange = (date, type) => {
    const { clientStatus, selectedCreatedDate, filteredStrategists, filteredTimings, filteredAgents, filteredSuburb, filterCount, selectedEndDate } = this.state
    if (type === "start") {
      this.setState({ selectedCreatedDate: date, selectedEndDate: "" })
    }
    if (type === "end") {
      this.setState({ selectedEndDate: date }, () => {
        let new_date_ref = selectedCreatedDate;
        if (!selectedCreatedDate || selectedCreatedDate == '') {
          new_date_ref = localStorage.getItem('from_date');
        }
        this.props.setfilterParams({
          clientStatus,
          filteredTimings,
          filteredStrategists,
          filteredTimings,
          filteredSuburb,
          filteredAgents,
          startDate: moment.utc(new_date_ref).format("YYYY-MM-DD"),
          endDate: moment.utc(date).format("YYYY-MM-DD"),
          filterCount
        })
      })
    }
    this.forceUpdate()
  }

  render() {
    const { userRole, filteredClientAgent, searchAgent, filteredClientSuburb, filteredClientStrategist, searchStatus, searchTimings, searchStrategist, searchSuburb, filterSearch, filteredClientTiming, filterStrategistDropdown, filterTimingsDropDown, filterSuburbDropdown, filterAgentDropdown } = this.state;

    return (
      <Popover
        content={
          <div className="filter">
            <div className="filter__header">
              <button className="btn btn__btn btn-secondry btn__xs" onClick={this.clearFilter}>Clear</button>
              <div className="filter__title">Filters</div>
              <button className="btn btn__btn btn-dark btn__xs" onClick={this.closeFilterModel}>Close</button>
            </div>
            <div className="filter__body">
              <ul className="filter__list">
                <li>
                  <label onClick={this.filterClick.bind(this, "status")} className="custom-checkbox custom-checkbox-line">
                    Status
                    <input
                      type="checkbox" name="status"
                      checked={this.state.status}
                      onChange={this.handleChange}
                      className="custom-checkbox--input"
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>
                {this.state.statusDropdown &&
                  <ul className="filter__list__inner">
                    <div className="search__form mt__10 mb__10">
                      <input
                        type="text"
                        className="form-control search__form__input"
                        onChange={this.handleChange}
                        name="searchStatus"
                        placeholder="Search for status..."
                        value={searchStatus} />
                    </div>
                    {filterSearch &&
                      map(filterSearch, (client, clientIdx) => {
                        const findSelected = find(this.state.clientStatus, o => o === client.name)
                        return (
                          <li key={`status__${clientIdx}`} >
                            <label style={{ fontSize: "14px" }} className="custom-checkbox custom-checkbox-line">
                              {client.name}
                              <input
                                type="checkbox"
                                checked={findSelected ? true : false} className="custom-checkbox--input"
                                onClick={this.filterClient.bind(this, client.name, 'filterStatus')}
                                readOnly
                              />
                              <span className="custom-checkbox-checkmark"></span>
                            </label>
                          </li>
                        );
                      })}
                  </ul>
                }
                <li>
                  <label onClick={this.filterClick.bind(this, "timings")} className="custom-checkbox custom-checkbox-line">
                    Timing
                    <input
                      type="checkbox" name="timings"
                      checked={this.state.timingCheckBox}
                      onChange={this.handleChange}
                      className="custom-checkbox--input"
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>
                {filterTimingsDropDown &&
                  <ul className="filter__list__inner">
                    <div className="search__form mt__10 mb__10">
                      <input
                        type="text"
                        className="form-control search__form__input"
                        onChange={this.handleChange}
                        name="searchTimings"
                        placeholder="Search for status..."
                        value={searchTimings} />
                    </div>
                    {filteredClientTiming &&
                      map(filteredClientTiming, (client, clientIdx) => {
                        const findSelected = find(this.state.filteredTimings, o => o === client.name)
                        return (
                          <li key={`timing__${clientIdx}`} >
                            <label style={{ fontSize: "14px" }} className="custom-checkbox custom-checkbox-line">
                              {client.name}
                              <input
                                type="checkbox"
                                checked={findSelected ? true : false} className="custom-checkbox--input"
                                onClick={this.filterClient.bind(this, client.name, 'filterTiming')}
                                readOnly
                              />
                              <span className="custom-checkbox-checkmark"></span>
                            </label>
                          </li>
                        );
                      })}
                  </ul>
                }
                {userRole !== "strategist" && <li>
                  <label onClick={this.filterClick.bind(this, "strategist")} className="custom-checkbox custom-checkbox-line">
                    Strategist
                    <input
                      type="checkbox"
                      name="strategists"
                      checked={this.state.strategists}
                      className="custom-checkbox--input"
                      onChange={this.handleChange}
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>}
                {filterStrategistDropdown &&
                  <ul className="filter__list__inner">
                    <div className="search__form mt__10 mb__10">
                      <input
                        type="text"
                        className="form-control search__form__input"
                        onChange={this.handleChange}
                        name="searchStrategist"
                        placeholder="Search for strategist..."
                        value={searchStrategist}
                      />
                    </div>
                    {filteredClientStrategist &&
                      map(filteredClientStrategist, (client, clientIdx) => {
                        const findSelected = find(this.state.filteredStrategists, o => o === client.id)
                        return (
                          <li key={`strategists__${clientIdx}`} >
                            <label style={{ fontSize: "14px" }} className="custom-checkbox custom-checkbox-line">
                              {client.strategist_name}
                              <input
                                type="checkbox"
                                checked={findSelected ? true : false} className="custom-checkbox--input"
                                onClick={this.filterClient.bind(this, client.id, 'filterStrategist')}
                                readOnly
                              />
                              <span className="custom-checkbox-checkmark"></span>
                            </label>
                          </li>
                        );
                      })}
                  </ul>
                }






                <li>
                  <label onClick={this.filterClick.bind(this, "agent")} className="custom-checkbox custom-checkbox-line">
                    Agent
                    <input
                      type="checkbox"
                      name="searchAgent"
                      checked={this.state.agents}
                      className="custom-checkbox--input"
                      onChange={this.handleChange}
                      value={this.state.searchAgent}
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>
                {filterAgentDropdown &&
                <ul className="filter__list__inner">
                  <div className="search__form mt__10 mb__10">
                    <input
                      type="text"
                      className="form-control search__form__input"
                      onChange={this.handleChange}
                      name="searchAgent"
                      placeholder="Search for agent..."
                      value={searchAgent}
                    />
                  </div>

                  {map(filteredClientAgent, (agent, agentIdx) => {
                    const optionSelected = find(this.state.filteredAgents, a => a === agent.id)
                    return (
                      <li key={`agents__${agentIdx}`} >
                        <label style={{ fontSize: "14px" }} className="custom-checkbox custom-checkbox-line">
                          {agent.agent_name}
                          <input
                            type="checkbox"
                            checked={optionSelected}
                            className="custom-checkbox--input"
                            onClick={this.filterClient.bind(this, agent.id, 'filterAgent')}
                            readOnly
                          />
                          <span className="custom-checkbox-checkmark"></span>
                        </label>
                      </li>
                    )
                  })}
                </ul>
                }



                {userRole !== "strategist" && <li>
                  <label onClick={this.filterClick.bind(this, "suburb")} className="custom-checkbox custom-checkbox-line">
                    Suburb
                    <input type="checkbox"
                      name="suburb"
                      checked={this.state.suburb}
                      className="custom-checkbox--input"
                      onChange={this.handleChange}
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>}
                {filterSuburbDropdown &&
                  <ul className="filter__list__inner">
                    <div className="search__form mt__10 mb__10">
                      <input
                        type="text"
                        className="form-control search__form__input"
                        onChange={this.handleChange}
                        name="searchSuburb"
                        placeholder="Search for suburbs..."
                        value={searchSuburb}
                      />
                    </div>
                    {filteredClientSuburb &&
                      map(filteredClientSuburb, (suburb, suburbIdx) => {
                        const findSelected = find(this.state.filteredSuburb, o => o === suburb.id)
                        return (
                          <li key={`suburb__${suburbIdx}`} >
                            <label style={{ fontSize: "14px" }} className="custom-checkbox custom-checkbox-line">
                              {suburb.name}
                              <input
                                type="checkbox"
                                checked={findSelected ? true : false} className="custom-checkbox--input"
                                onClick={this.filterClient.bind(this, suburb.id, 'filterSuburb')}
                                readOnly
                              />
                              <span className="custom-checkbox-checkmark"></span>
                            </label>
                          </li>
                        );
                      })}
                  </ul>
                }
                {userRole !== "strategist" &&
                  <Fragment>
                    <li>
                      <label onClick={this.filterClick.bind(this, "createdDate")} className="custom-checkbox custom-checkbox-line">
                        Created Date
                        <input type="checkbox"
                          name="createdDate"
                          checked={this.state.createdDate}
                          className="custom-checkbox--input"
                          onChange={this.handleChange}
                        />
                        <span className="custom-checkbox-checkmark"></span>
                      </label>
                    </li>
                    {this.state.createdDate && <ul className="filter__list__inner">
                      <div className="search__form mt__10 mb__10">
                        <DatePicker
                          className="datepicker__follow-up-date form-control search__form__input"
                          dropdownClassName="datepicker__overlay__follow-up-date"
                          format="MM/DD/YYYY"
                          onChange={(date) => this.handleDateChange(date, "start")}
                          value={this.state.selectedCreatedDate}
                          placeholder="Select Start Date"
                          disabledDate={(value) => value > new Date()}
                        />
                      </div>
                    </ul>}
                    {this.state.selectedCreatedDate && <ul className="filter__list__inner">
                      <div className="search__form mt__10 mb__10">
                        <DatePicker
                          className="datepicker__follow-up-date form-control search__form__input"
                          dropdownClassName="datepicker__overlay__follow-up-date"
                          format="MM/DD/YYYY"
                          disabledDate={(value) => value < this.state.selectedCreatedDate || value > new Date()}
                          onChange={(date) => this.handleDateChange(date, "end")}
                          value={this.state.selectedEndDate}
                          placeholder="Select End Date"
                        />
                      </div>
                    </ul>}
                  </Fragment>}
              </ul>
            </div>
          </div>
        }
        placement="bottom"
        className="filter"
        overlayClassName="filter__overlay"
        // title="Title"
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.filterVisible}
      >
        <button className="btn btn-dark btn-filter"><FilterIcon className="filter-icon" /> Filters{this.state.filterCount > 0 && `(${this.state.filterCount})`}</button>
      </Popover>
    )
  }
}
